<template>
    <div class="transfer-topbar" :class="theme">
        <div class="wrapper flex" :class="topbarClass">
            <div class="btn-back flex"  @click="clickBackHome()">
                <img v-if="stage == 'init'" src="../../assets/back.svg" />
                <img v-else src="../../assets/back-gray.svg" />
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "Topbar",
    props: {
        theme: String,
        stage: String
    },
    components: {

    },
    data: function() {
        return {
        }
    },
    created: function() {

    },
    computed:{
        topbarClass: function(){
            let classTopbar = '';
            switch (this.stage) {
                case 'init':
                        classTopbar = 'wrapper'
                    break;
                case 'tier':
                        classTopbar = 'wrapper-gray'
                    break;

                default:
                        classTopbar = 'wrapper-white'
                    break;
            }
            return classTopbar;
        }
    },
    mounted: function() {

    },
    methods: {
        clickBackHome: function() {
            this.$emit("clickBack");
        },
    }
}
</script>
<style lang="scss" scoped>
@import "../../style/base.scss";
@import "style/TopBar.scss";

.margin-fix{
    margin-bottom: -4px;
}
</style>

